import { c as _c } from "react/compiler-runtime";
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@achra/ui/empty';
import { Folder } from 'lucide-react';
function BudgetEmptyState() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex h-fit flex-col gap-6"><Empty><EmptyHeader><EmptyMedia variant="icon"><Folder /></EmptyMedia><EmptyTitle>No budget statements found</EmptyTitle><EmptyDescription>There are no contributors available with this combination of filters</EmptyDescription></EmptyHeader></Empty></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export { BudgetEmptyState };